export default __webpack_public_path__ + "img/androidwhitemovil.917afdc2.svg";